// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c-model-wrap[data-v-0bd5ddce]{position:fixed;top:0;left:0;width:100%;height:100%;background:#00000059;z-index:9999;overflow:auto}.c-model[data-v-0bd5ddce]{width:100%;max-width:1000px;position:relative}.c-model-close[data-v-0bd5ddce]{position:absolute;right:22px;top:22px;z-index:9}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
